module.exports = __webpack_public_path__ + "static/video4-3d447ddd43068413bf269d5ec79c3c5a.png";